export const createContract = {
  // ── Page / Breadcrumb ──────────────────────────────────────────────────────
  CC_PAGE_TITLE:              'Skapa kundavtal',
  CC_CONTRACT_NO_LABEL:       'Avtalsnummer',
  CC_HEADER_EYEBROW:          'Nytt dokument',
  CC_PAGE_SUBTITLE:           'På den här sidan kan du skapa ett kundavtal genom att lägga till parterna, uppdragets omfattning, ersättning och signaturer – allt på ett ställe.',

  // ── Stepper ────────────────────────────────────────────────────────────────
  CC_STEP_COMPANY_LOGO:       'Företagslogotyp',
  CC_STEP_PARTIES_INFO:       'Partsinformation',
  CC_STEP_ASSIGNMENT:                'Uppdrag',
  CC_STEP_COMPENSATION:             'Ersättning',
  CC_STEP_ASSIGNMENT_COMPENSATION:  'Uppdrag & Ersättning',
  CC_STEP_LEGAL_SIGNATURES:         'Juridik & Signaturer',
  CC_STEP_COMPANY_LOGO_SUB:            'Profilera dokumentet',
  CC_STEP_PARTIES_INFO_SUB:            'Vilka är inblandade',
  CC_STEP_ASSIGNMENT_COMPENSATION_SUB: 'Omfattning & betalning',
  CC_STEP_LEGAL_SIGNATURES_SUB:        'Granska & signera',

  // ── Step 0 — Company Logo ──────────────────────────────────────────────────
  CC_LOGO_CARD_TITLE:         'Företagslogotyp',
  CC_LOGO_CARD_SUBTITLE:      'Ladda upp din företagslogotyp för att personifiera tjänsteavtalsdokumentet.',
  CC_LOGO_CLICK_TO_UPLOAD:    'Klicka för att ladda upp',
  CC_LOGO_CHANGE_IN_SETTINGS: 'Ändra logotyp i profilinställningar',
  CC_LOGO_SETTINGS_NOTE:      'Din företagslogotyp är konfigurerad i dina profilinställningar och visas på alla dokument.',
  CC_LOGO_PROFILE_SUMMARY:    'Din profil',
  CC_INVOZIO_INFO_TITLE:      'Invozio-information',
  CC_INVOZIO_INFO_COMPANY:    'Invozio LV SIA',
  CC_INVOZIO_INFO_REG:        '502085-4062',
  CC_INVOZIO_INFO_REF:        '(Nedan kallad "Invozio")',
  CC_PREFERRED_LANGUAGE_LABEL: 'Föredraget språk',
  CC_PREFERRED_LANGUAGE_HINT:  'Språket det här avtalet (och dess dokument/e-post) skapas på. Är förvalt till ditt plattformsspråk första gången, och kommer sedan ihåg ditt senaste val.',

  // ── Step 1 — Parties Information ───────────────────────────────────────────
  CC_PARTIES_CUSTOMER_INFO:           'Kundinformation',
  CC_PARTIES_ADD_CUSTOMER:            'Lägg till ny kund',
  CC_PARTIES_SELECT_LABEL:            'Välj befintlig kund:',
  CC_PARTIES_SELECT_PLACEHOLDER:      'Välj kund',
  CC_PARTIES_REMOVE_CUSTOMER:         'Ta bort',
  CC_PARTIES_CUSTOMER_NAME_LABEL:     'Kundnamn:',
  CC_PARTIES_CUSTOMER_NAME_HINT:      'Ange kundnamn',
  CC_PARTIES_ORG_NUMBER_LABEL:        'Organisationsnummer:',
  CC_PARTIES_ORG_NUMBER_HINT:         '12345678-9900',
  CC_PARTIES_BILLING_ADDRESS_LABEL:   'Kundens faktureringsadress:',
  CC_PARTIES_BILLING_ADDRESS_HINT:    'Ange faktureringsadress',
  CC_PARTIES_OFFERED_SERVICES_LABEL:  'Erbjudna tjänster',
  CC_PARTIES_OFFERED_SERVICES_HINT:   't.ex. Konsulttjänster',
  CC_PARTIES_ASSIGN_PERIOD_LABEL:     'Uppdragsperiod',
  CC_PARTIES_ASSIGN_PERIOD_HINT:      't.ex. Löpande',
  CC_PARTIES_WORK_DESC_LABEL:         'Specificera arbetet och vad som ingår:',
  CC_PARTIES_WORK_DESC_HINT:          'Beskriv uppdragets omfattning',
  CC_PARTIES_SPECIAL_TERMS_LABEL:     'Särskilda villkor:',
  CC_PARTIES_SPECIAL_TERMS_HINT:      'Ange eventuella särskilda villkor...',
  CC_PARTIES_NO_CUSTOMERS:            'Kunden hittades inte',

  // ── Step 2 — Assignment ────────────────────────────────────────────────────
  CC_ASSIGN_PERIOD_TITLE:       'Avtalsperiod',
  CC_ASSIGN_START_DATE:         'Startdatum',
  CC_ASSIGN_END_DATE:           'Slutdatum',
  CC_DATE_PLACEHOLDER:          'åååå/mm/dd',
  CC_ASSIGN_NO_END_DATE:        'Inget slutdatum',
  CC_ASSIGN_NO_END_DATE_INFO:   'Markera om uppdraget löper tills vidare utan ett bestämt slutdatum.',
  CC_ASSIGN_NOTICE_CHECKBOX:    'Uppsägningstid',
  CC_ASSIGN_NOTICE_INFO:        'Markera om endera parten måste meddela i förväg innan uppdraget avslutas i förtid.',
  CC_ASSIGN_NOTICE_LABEL:       'Uppsägningstid',
  CC_ASSIGN_NOTICE_1M:          '1 månad',
  CC_ASSIGN_NOTICE_2M:          '2 månader',
  CC_ASSIGN_NOTICE_3M:          '3 månader',
  CC_ASSIGN_NOTICE_6M:          '6 månader',
  CC_ASSIGN_NOTICE_HINT:        'Kunden måste meddelas så här lång tid innan avtalets slutdatum.',
  CC_ASSIGN_DESC_TITLE:         'Uppdragsbeskrivning',
  CC_ASSIGN_DESC_LABEL:         'Beskriv de tjänster och leveranser som ska tillhandahållas inom ramen för detta avtal.',
  CC_ASSIGN_DESC_HINT:          'Ange en detaljerad beskrivning av uppdraget...',

  // ── Step 3 — Compensation ──────────────────────────────────────────────────
  CC_COMP_TITLE:                'Ersättningsdetaljer',
  CC_COMP_TYPE_LABEL:           'Ersättningstyp',
  CC_COMP_TYPE_PLACEHOLDER:     'Välj typ',
  CC_COMP_TYPE_PER_HOUR:        'Betalning per timme',
  CC_COMP_TYPE_PER_DAY:         'Betalning per dag',
  CC_COMP_TYPE_PER_WEEK:        'Betalning per vecka',
  CC_COMP_TYPE_PER_MONTH:       'Betalning per månad',
  CC_COMP_TYPE_AS_AGREED:       'Fast pris',
  CC_COMP_TYPE_PER_UNIT:        'Betalning per enhet',
  CC_COMP_UNIT_LABEL:           'Antal enheter',
  CC_COMP_UNIT_HINT:            't.ex. 10',
  CC_COMP_CURRENCY_LABEL:       'Valuta',
  CC_COMP_AMOUNT_LABEL:         'Belopp',
  CC_COMP_AMOUNT_HINT:          'Ange belopp',
  CC_COMP_INVOICE_NOTE:         'Fakturering för utfört arbete sker månadsvis. Betalningsvillkor är 30 dagar. Påminnelseavgift om 60 SEK och inkassoavgift om 180 SEK tillämpas, eller de belopp som annars föreskrivs av lag. Dröjsmålsränta tillkommer.',

  // ── Step 4 — Legal & Signatures ───────────────────────────────────────────
  CC_LEGAL_CARD_TITLE:               'Juridiska villkor',
  CC_LEGAL_TAXES_HEADING:            'Skatter och avgifter',
  CC_LEGAL_TAXES_BODY:               'Ersättningen är exklusive moms. Invozio ansvarar ensam för löneadministration, skatteavdrag, sociala avgifter och andra lagstadgade skyldigheter relaterade till tjänsteutföraren. På skälig begäran ska Invozio kunna styrka att dessa skyldigheter har fullgjorts.',
  CC_LEGAL_INSURANCE_HEADING:        'Försäkring',
  CC_LEGAL_INSURANCE_BODY:           'Invozio upprätthåller försäkringsskydd i enlighet med de försäkringslösningar som vid var tid gäller för verksamheten. Försäkringsskyddet omfattas av villkoren, begränsningarna, undantagen och ersättningsnivåerna i respektive försäkringsavtal.',
  CC_LEGAL_CONFIDENTIALITY_HEADING:  'Sekretess',
  CC_LEGAL_CONFIDENTIALITY_BODY:     'Den egenanställde och Invozio förbinder sig att inte röja konfidentiell information som erhållits genom uppdraget, annat än när det krävs enligt lag eller för administrationen av uppdraget.',
  CC_LEGAL_ROLE_HEADING:             'Tjänsteutförarens ansvar',
  CC_LEGAL_ROLE_BODY:                'Tjänsterna utförs av en självständig tjänsteutförare som anlitas genom Invozio. Tjänsteutföraren ansvarar ensam för tjänsternas utförande, kvalitet, kompetens, kvalifikationer och leverans. Invozios roll är begränsad till administrativa tjänster såsom fakturering, lönehantering, försäkring och regelefterlevnad.',
  CC_LEGAL_LIMITATION_HEADING:       'Ansvarsbegränsning',
  CC_LEGAL_LIMITATION_BODY:          'Invozios totala ansvar enligt detta avtal ska aldrig överstiga de avgifter som Kunden har betalat till Invozio under de tolv (12) månader som föregått kravet.',
  CC_LEGAL_ACK_HEADING:              'Kundbekräftelse',
  CC_LEGAL_ACK_BODY:                 'Kunden bekräftar att samtliga tjänster tillhandahålls direkt av Frilansaren, som ensam och exklusivt ansvarar för uppdragets omfattning, kvalitet, genomförande och leverans.',
  CC_LEGAL_CONFIRM_TEXT:             'Jag bekräftar att all information som lämnats för detta avtal är korrekt och fullständig enligt min bästa vetskap. Jag förstår att denna information kommer att användas för att upprätta det slutliga avtalsdokumentet och att jag är personligen ansvarig för den inlämnade informationen samt eventuella konsekvenser av felaktigheter.',

  // ── Signatures ─────────────────────────────────────────────────────────────
  CC_SIG_CARD_TITLE:          'Signaturer',
  CC_SIG_FREELANCER_LABEL:    'På uppdrag av frilansaren:',
  CC_SIG_DATE_LABEL:          'Datum',
  CC_SIG_PLACE_LABEL:         'Ort',
  CC_SIG_SIGNATURE_LABEL:     'Underskrift',
  CC_SIG_DRAW_BTN:            'Rita underskrift',
  CC_SIG_UPLOAD_BTN:          'Ladda upp underskrift',
  CC_SIG_CANVAS_HINT_DRAW:    'Rita din underskrift här',
  CC_SIG_CANVAS_HINT_UPLOAD:  'Din uppladdade underskrift visas här',
  CC_SIG_CLEAR_BTN:           'Rensa',
  CC_SIG_NAME_LABEL:          'Namnförtydligande',
  CC_SIG_NAME_HINT:           'Ange ditt fullständiga namn',
  CC_SIG_INVOZIO_LABEL:       'På uppdrag av Invozio LV SIA:',
  CC_SIG_INVOZIO_PRE_SIGNED:  'Digitalt förtecknat',
  CC_SIG_CUSTOMER_LABEL:       'På uppdrag av kunden:',
  CC_SIG_CUSTOMER_PENDING_BADGE: 'Väntar på signering',
  CC_SIG_CUSTOMER_SIGNED_BADGE:  'Signerad',
  CC_SIG_CUSTOMER_PENDING_BODY:  'Kunden signerar efter att du har skickat avtalet.',
  CC_SIG_CUSTOMER_PLACEHOLDER_NAME: 'Kund',

  // ── Footer actions ─────────────────────────────────────────────────────────
  CC_BTN_CANCEL:     'Avbryt',
  CC_BTN_BACK:       'Tillbaka',
  CC_BTN_NEXT:       'Nästa',
  CC_BTN_SUBMIT:     'Skicka in',
  CC_BTN_SUBMITTING:     'Skickar…',
  CC_BTN_SAVE_DRAFT:     'Spara som utkast',
  CC_BTN_SAVING_DRAFT:   'Sparar…',
  CC_BTN_SEND_AGREEMENT: 'Skicka avtal för signering',
  CC_BTN_SENDING:        'Skickar…',

  // ── Validation messages ────────────────────────────────────────────────────
  CC_VAL_FIELD_REQUIRED:      'Detta fält är obligatoriskt.',
  CC_VAL_CUSTOMER_REQUIRED:   'Välj en kund.',
  CC_VAL_END_DATE_REQUIRED:   "Ange ett slutdatum eller markera 'Inget slutdatum'.",
  CC_VAL_END_AFTER_START:     'Slutdatumet måste vara efter startdatumet.',
  CC_VAL_AMOUNT_POSITIVE:     'Ange ett giltigt belopp större än 0.',
  CC_VAL_TERMS_REQUIRED:      'Godkänn de juridiska villkoren för att fortsätta.',
  CC_VAL_SIGNATURE_REQUIRED:  'Lägg till en underskrift.',

  // ── Toast messages ─────────────────────────────────────────────────────────
  CC_TOAST_CONFIRM_REQUIRED:  'Vänligen bekräfta att all information är korrekt.',
  CC_TOAST_CUSTOMER_REQUIRED: 'Välj en kund innan du skickar in.',
  CC_TOAST_FILL_REQUIRED:     'Fyll i de obligatoriska fälten',
  CC_TOAST_SUCCESS:           'Avtalet skapades framgångsrikt!',
  CC_TOAST_ERROR:             'Det gick inte att skapa avtalet. Försök igen.',
  CC_TOAST_UPDATE_SUCCESS:    'Avtalet uppdaterades framgångsrikt!',
  CC_TOAST_UPDATE_ERROR:      'Det gick inte att uppdatera avtalet. Försök igen.',
  CC_TOAST_LOAD_ERROR:        'Det gick inte att ladda avtalet. Försök igen.',
  CC_TOAST_SEND_SUCCESS:      'Avtalet sparades och skickades till kunden för signering!',
  CC_TOAST_SEND_ERROR:        'Det gick inte att skicka avtalet till kunden. Försök igen.',
  CC_TOAST_SEND_LOOKUP_ERROR: 'Avtalet sparades, men kunde inte skickas automatiskt. Skicka det istället från avtalslistan.',

  // ── Send-agreement preview modal ───────────────────────────────────────────
  CC_PREVIEW_MODAL_TITLE: 'Granska innan du skickar',
  CC_PREVIEW_MODAL_SUBTITLE: 'Förhandsgranska avtalet precis som din kund kommer att få det.',
  CC_PREVIEW_SEND_TO:     'Det här avtalet skickas till {{name}} ({{email}}).',
  CC_PREVIEW_SWIPE_UP:    'Svep upp',
  CC_PREVIEW_SWIPE_DOWN:  'Svep ner',
  CC_PREVIEW_DOWNLOAD:    'Ladda ner PDF',
  CC_BTN_CONFIRM_SEND:    'Granska och skicka',

  // ── Edit mode ──────────────────────────────────────────────────────────────
  CC_PAGE_TITLE_EDIT: 'Redigera kundavtal',
  CC_BTN_UPDATE:      'Uppdatera',
  CC_BTN_UPDATING:    'Uppdaterar…',
  CC_LOADING_CONTRACT: 'Laddar avtal…',

  // ── Contracts grid ─────────────────────────────────────────────────────────
  CCG_TITLE:             'Dina avtal',
  CCG_LOADING:           'Laddar avtal…',
  CCG_ERROR:             'Det gick inte att ladda avtal. Uppdatera sidan.',
  CCG_EMPTY:             'Inga avtal ännu.',
  CCG_EMPTY_ARCHIVED:    'Inga arkiverade avtal.',
  CCG_CREATE_FIRST:      'Skapa ditt första avtal',
  CCG_TAB_ALL:           'Alla',
  CCG_TAB_ARCHIVED:      'Arkiverade',
  CCG_COL_CONTRACT_NO:   'Avtalsnr.',
  CCG_COL_CUSTOMER:      'Kund',
  CCG_COL_START_DATE:    'Startdatum',
  CCG_COL_END_DATE:      'Slutdatum',
  CCG_COL_AMOUNT:        'Belopp',
  CCG_COL_STATUS:        'Status',
  CCG_COL_CREATED:       'Skapad',
  CCG_NO_END_DATE:       'Inget slutdatum',
  CCG_STATUS_DRAFT:             'Utkast',
  CCG_STATUS_PENDING_SIGNATURE: 'Väntar på signering',
  CCG_STATUS_ACTIVE:            'Signerad/Aktiv',
  CCG_STATUS_EXPIRED:           'Utgången',
  CCG_STATUS_CANCELLED:         'Avbruten',
  CCG_STATUS_ARCHIVED:          'Arkiverat',
  CCG_COL_ACTIONS:       'Åtgärder',
  CCG_ACTION_DOWNLOAD_PDF: 'Ladda ned PDF',
  CCG_ACTION_EDIT:       'Redigera avtal',
  CCG_ACTION_EDIT_DISABLED: 'Endast avtal med status Utkast kan redigeras',
  CCG_ACTION_EDIT_DISABLED_ARCHIVED: 'Arkiverade avtal kan inte redigeras',
  CCG_DOWNLOAD_SUCCESS:  'PDF nedladdad.',
  CCG_DOWNLOAD_ERROR:    'Det gick inte att ladda ned PDF. Försök igen.',
  CCG_ACTION_SEND:           'Skicka till kund',
  CCG_ACTION_SEND_DISABLED_ARCHIVED: 'Arkiverade avtal kan inte skickas',
  CCG_ACTION_SEND_DISABLED_EXPIRED: 'Utgångna avtal kan inte skickas. Duplicera det för att skapa en ny version.',
  CCG_ACTION_SEND_DISABLED_ACTIVE: 'Det här avtalet är redan aktivt och kan inte skickas igen.',
  CCG_ACTION_SEND_DISABLED_CANCELLED: 'Avbrutna avtal kan inte skickas.',
  CCG_ACTION_DUPLICATE:      'Duplicera / Skapa ny version',
  CCG_SEND_NO_EMAIL:         'Den här kunden har ingen registrerad e-postadress.',
  CCG_SEND_SUCCESS:          'Avtalet har skickats via e-post.',
  CCG_SEND_ERROR:            'Det gick inte att skicka avtalet. Försök igen.',
  CCG_ACTION_ARCHIVE:        'Arkivera avtal',
  CCG_ACTION_UNARCHIVE:      'Återställ avtal',
  CCG_ARCHIVE_SUCCESS:       'Avtalet har arkiverats.',
  CCG_ARCHIVE_ERROR:         'Det gick inte att arkivera avtalet. Försök igen.',
  CCG_UNARCHIVE_SUCCESS:     'Avtalet har återställts.',
  CCG_UNARCHIVE_ERROR:       'Det gick inte att återställa avtalet. Försök igen.',

  // ── Public customer contract sign/decline page ────────────────────────────
  CCSIGN_PAGE_TITLE:           'Kundavtal',
  CCSIGN_PAGE_SUBTITLE:        'Granska avtalet nedan innan du accepterar eller avböjer det.',
  CCSIGN_LOADING:              'Laddar avtal…',
  CCSIGN_LOAD_ERROR_TITLE:     'Länken är inte längre giltig',
  CCSIGN_LOAD_ERROR_BODY:      'Vi kunde inte ladda det här avtalet. Länken kan ha upphört att gälla, redan använts eller vara ogiltig.',
  CCSIGN_PDF_CARD_TITLE:       'Avtalsdokument',
  CCSIGN_BTN_ACCEPT:           'Acceptera & signera',
  CCSIGN_BTN_DECLINE:          'Avböj',
  CCSIGN_SIGN_CARD_TITLE:      'Bekräfta & signera',
  CCSIGN_SIGNATURE_LABEL:      'Underskrift',
  CCSIGN_CANVAS_HINT:          'Rita din underskrift här',
  CCSIGN_CLEAR_BTN:            'Rensa',
  CCSIGN_NAME_LABEL:           'Namnförtydligande',
  CCSIGN_NAME_HINT:            'Ange ditt fullständiga namn',
  CCSIGN_TERMS_CONFIRM_TEXT:   'Jag har granskat avtalet ovan och accepterar dess villkor.',
  CCSIGN_BTN_CONFIRM_SIGN:     'Bekräfta & signera',
  CCSIGN_BTN_SIGNING:          'Signerar…',
  CCSIGN_BTN_CANCEL:           'Avbryt',
  CCSIGN_DECLINE_CARD_TITLE:   'Avböj avtal',
  CCSIGN_DECLINE_REASON_LABEL: 'Berätta gärna varför du avböjer det här avtalet:',
  CCSIGN_DECLINE_REASON_HINT:  'Ange din anledning...',
  CCSIGN_BTN_CONFIRM_DECLINE:  'Bekräfta avböjning',
  CCSIGN_BTN_DECLINING:        'Avböjer…',
  CCSIGN_VAL_SIGNATURE_REQUIRED: 'Lägg till en underskrift.',
  CCSIGN_VAL_NAME_REQUIRED:      'Ange ditt fullständiga namn.',
  CCSIGN_VAL_TERMS_REQUIRED:     'Bekräfta att du accepterar avtalet.',
  CCSIGN_VAL_REASON_REQUIRED:    'Ange en anledning.',
  CCSIGN_SIGN_SUCCESS_TITLE:   'Avtalet signerat',
  CCSIGN_SIGN_SUCCESS_BODY:    'Tack — avtalet har signerats. Du kan nu stänga det här fönstret.',
  CCSIGN_SIGN_ERROR:           'Det gick inte att skicka din underskrift. Försök igen.',
  CCSIGN_BTN_DOWNLOAD:         'Ladda ned signerat avtal',
  CCSIGN_BTN_DOWNLOADING:      'Laddar ned…',
  CCSIGN_DOWNLOAD_ERROR:       'Det gick inte att ladda ned det signerade avtalet. Försök igen.',
  CCSIGN_DECLINE_SUCCESS_TITLE: 'Avtalet avböjt',
  CCSIGN_DECLINE_SUCCESS_BODY:  'Du har avböjt det här avtalet. Avsändaren har meddelats.',
  CCSIGN_DECLINE_ERROR:         'Det gick inte att skicka din avböjning. Försök igen.',
};
